import { JL } from 'jsnlog'
import uuidv4 from 'uuid/v4'
import UrlUtil from '@/util/Url'
import AuthUtil from '@/util/AuthUtil'
import store from '@/store'

const defaultOptions = {
  defaultAjaxUrl: `${UrlUtil.getApiUrl()}/front-end-error`,
  requestId: uuidv4().toString(),
  maxMessages: 5,
  defaultBeforeSend: function (xhr) {
    xhr.setRequestHeader('Authorization', AuthUtil.getAuthorizationHeader())
    xhr.setRequestHeader('verofresh-customer-context', store.getters['userModule/customerContextId'])
    xhr.setRequestHeader('verofresh-client-version', store.getters['appMetadataModule/version'])
  }
}

JL.setOptions(defaultOptions)

// When we go into maintenance mode, disable JL. When we leave it, turn it back on.
store.watch(
  (state) => store.state.globalMessagingModule.maintenanceMode,
  (newValue, oldValue) => {
    if (newValue === true) {
      JL.setOptions({ enabled: false })
    } else {
      JL.setOptions(defaultOptions)
    }
  }
)

export default {
  handler: function (error, vm, info) {
    // Log errors to the console in pre-build environments (such as our
    // sandboxes). The ConsoleAppender provided by JSNLog stringifyies the error
    // making it hard to interpret so just to a standard console log
    if (store.getters['appMetadataModule/version'] === 'pre-build') {
      // In this case we really *do* want logs to be sent to the console (even
      // in production)
      console.error(error) // eslint-disable-line
    }

    JL().fatalException('error', error)
  }
}
